/* Devroldan */
import { AfterViewInit, Inject, EventEmitter, ElementRef, Input, Output, HostListener } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { ProductZoomComponent } from './product-zoom/product-zoom.component';
import { ListsSandbox } from '../../../../core/lists/lists.sandbox';
import { ConfigService } from '../../../../core/service/config.service';
import { MatDialog } from '@angular/material';
import { CommonSandbox } from 'src/core/common/common.sandbox';
import { Store } from '@ngrx/store';
import { AppState } from 'src/core/state.interface';
import {
  ObtenerDireccionesAction,
  AgregarDireccionAction,
  EliminarDireccionAction,
  SubirImagenDisenioAction,
  AgregarAdjuntoImagenDisenioAction,
  EliminarAdjuntoDisenioAction,
  AgregarTextoDisenioAction,
  AgregarLogoDisenioAction,
  AgregarReferenciaDisenioAction
} from 'src/core/clientes/action/acciones';

import { DireccionDialog } from './ventanas-emergentes/direcciones/dialog-direccion.component';
import { CargaDisenioDialog } from './ventanas-emergentes/carga-imagen-disenio/carga-disenio.component';
import { ConfirmacionDialog } from './ventanas-emergentes/confirmacion/confirmacion.component';
import { ProductControlSandbox } from 'src/core/product-control/product-control.sandbox';
import { GetProfile } from 'src/core/common/action/common.action';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { map, startWith } from 'rxjs/operators';




@Component({
  selector: 'app-producto',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class ProductComponent2 implements OnInit, OnDestroy, AfterViewInit {
  // decorator
  @ViewChild('zoomViewer') zoomViewer;
  @ViewChild('fileInput') fileInput;
  @ViewChild('stepper') stepper;
  @ViewChild('precioDinamico') precioDinamicoElement: ElementRef;


  @Input() idProductoCarrito;
  @Input() indiceCarrito;
  @Input() productoCounteo;
  @Input() dataFormulario;
  @Input() idCliente;
  @Input() idOrden;
  @Output()
  cotizacion = new EventEmitter<any>();

  actualizarOrdenOCotizacion() {
    let indexSeleccionado = 2;

    const dialogRef = this.dialog.open(
      this.arrayConfirmaciones[indexSeleccionado].type,
      this.arrayConfirmaciones[indexSeleccionado].params
    );
    this.subscriptions.push(
      this.subsDialog = dialogRef.afterClosed().subscribe(this.arrayConfirmaciones[indexSeleccionado].subscribe)
    );
  }

  confirmarAgregarCarrito(): void {

    if (!this.clienteSeleccionado || !this.perfilSeleccionado) {
      alert("Por favor, seleccione un cliente y un solicitante.");
      return;
    }

    let indexSeleccionado = 2;

    const dialogRef = this.dialog.open(
      this.arrayConfirmaciones[indexSeleccionado].type,
      this.arrayConfirmaciones[indexSeleccionado].params
    );
    this.subscriptions.push(
      this.subsDialog = dialogRef.afterClosed().subscribe(this.arrayConfirmaciones[indexSeleccionado].subscribe)
    );
  }

  // configuration
  public config: SwiperConfigInterface = {};
  public config2: SwiperConfigInterface = {};
  public configuration: SwiperConfigInterface = {};
  public product: any;
  //Está en ventana emergente
  public estaEnVentanaEmergente = false;
  // Variable para la altura de la ventana
  public alturaVentana: number = window.innerHeight;
  // images
  public image: any;
  public zoomImage: any;
  public imagePath: string;
  public productImageId: number;
  // route params
  private sub: any;
  private id: any;
  private cliente_id: string;
  private perfil_id: string;
  // available options
  public templateHidden: number;
  public cantidad: number;
  public unidad_medida: string;
  public nombre_unidad: string;

  public unidad_medida_label1: string;
  public unidad_medida_label2: string;

  public direcciones$;
  public disenioImagen$;
  public adjuntosDisenioImagen$;
  public direccionesSeleccionadas = [];

  public clientes: any[] = [];
  public clienteSeleccionado: any = null;
  public clienteSeleccionado_id: any = null;
  public perfilSeleccionado: any = null;
  public actualizarPer: boolean = false;

  perfilesFacturacion: any[];
  tipoSeleccionado: any = 'Contacto';
  labelSeleccionado: any = "Solicitantes";


  public opcionDisenioEscojida = 0;

  public tipoDescuentoLabels = {
    cliente: 'Contacto',
    perfil: 'Perfil',
    grupo: 'Grupo'
  };

  // subcription
  private subscriptions: Array<any> = [];
  isActive = [];
  yaPuedeActualizarPreciosEditar: boolean;
  constructor(
    private activatedRoute: ActivatedRoute,
    public formBuilder: FormBuilder,
    public dialog: MatDialog,
    public productDetail: ListsSandbox,
    public controlSandbox: ProductControlSandbox,
    public commonSandbox: CommonSandbox,
    private configService: ConfigService,
    private changeDetectRef: ChangeDetectorRef,
    private appState$: Store<AppState>,
    private router: Router,
    private http: HttpClient,
  ) {
    window["productRef2"] = this;
    this.router.events.subscribe(evt => {
      if (evt instanceof NavigationEnd) {//123
        this.router.navigated = true;
        window.scrollTo(0, 0);
      }

    });


  }

  abrirClienteContacto = false;
  tipoClienteContacto: string = "";
  hijo: boolean = true;
  padre: any = null;

  ventanaClienteContacto(par) {
    this.abrirClienteContacto = par;
  }

  agregarUnContacto() {
    this.hijo = false;
    this.padre = false;
    this.tipoClienteContacto = "contacto";
    this.ventanaClienteContacto(true);
  }

  agregarUnCliente() {
    this.hijo = false;
    this.padre = false;
    this.tipoClienteContacto = "cliente";
    this.ventanaClienteContacto(true);
  }

  agregarHijo() {
    this.padre = this.clienteSeleccionado;
    this.ventanaClienteContacto(true);
    this.hijo = true;
  }

  entidadAgregada(res) {
    this.abrirClienteContacto = false;
    if (res.union) {
      if (res.padre.tipo == "contacto") {
        this.perfilesFacturacion.unshift(res.hijo);
        this.perfilSeleccionado = this.perfilesFacturacion[0].id;
        this.cambiaGenerico('perfil');
      } else if (res.padre.tipo == "cliente") {
        this.perfilesFacturacion.unshift(res.hijo);
        this.perfilSeleccionado = this.perfilesFacturacion[0].id;
        this.cambiaGenerico('perfil');

      }
    } else {

      if (!res.hijo) {
        this.options.unshift(res.datos);
        if (this.clientes) {

          this.clientes.unshift(res.datos);
          this.clienteSeleccionado = this.clientes[0];
          this.cambiaGenerico('cliente');
        } else {

        }
        window.location.reload();
      } else {
        this.perfilesFacturacion.unshift(res.datos);
        this.perfilSeleccionado = this.perfilesFacturacion[0].id;
        this.cambiaGenerico('perfil');
      }
    }

  }







  userRol: string = "cliente";
  dataUser: any = {};
  clienteAux = "";


  ngOnInit() {

    let _cliente_id = localStorage.getItem("cliente_id") || "";
    let _perfil_id = localStorage.getItem("perfil_id") || "";
    this.clienteAux = JSON.parse(localStorage.getItem("cliente_seleccionado") || "[]");
    setTimeout(() => {
      if (this.clienteAux && this.clienteAux.length == 1) {
        this.clienteSeleccionado = this.clienteAux[0];
      }
      this.changeDetectRef.detectChanges();
    }, 3000);

    this.appState$.dispatch(new ObtenerDireccionesAction(466));
    this.imagePath = this.configService.getImageUrl();
    this.sub = this.activatedRoute.params.subscribe(params => {
      let getProductoR = () => {
        if (!params["id"] || this.idProductoCarrito) {

          this.estaEnVentanaEmergente = true;

        }
        return params["id"] || this.idProductoCarrito;
      };
      this.id = getProductoR();
      this.getProductdetail();
      this.getBannerList();
    });
    this._ngOnInit();
    this.direcciones$ = this.appState$.select('direcciones');
    this.disenioImagen$ = this.appState$.select('imagenDisenio');

    this.subscriptions.push(
      this.disenioImagen$.subscribe(data => {
        setTimeout(() => {
          this.changeDetectRef.detectChanges();
        }, 100)
      })
    );

    this.adjuntosDisenioImagen$ = this.appState$.select('adjuntosDisenioImagen');
    this.subscriptions.push(
      this.adjuntosDisenioImagen$.subscribe((_data) => {
        if (_data)
          this.nArchivos = _data.length;
      })
    );

    this.subscriptions.push(
      this.commonSandbox.getProfile$.subscribe(data => {
        if (data) {
          this.dataUser = JSON.parse(localStorage.getItem("user"));
          if (!this.dataUser["vendedor_id"])
            this.appState$.dispatch(new ObtenerDireccionesAction(this.cliente_id));
          else {
            this.clientes = this.dataUser.clientes;
            this.changeDetectRef.detectChanges();
          }
          this.actualizarPer = false;
          setTimeout(() => {
            this.actualizarPer = true;
            this.perfilSeleccionado = parseFloat(_perfil_id || "0");
            this.changeDetectRef.detectChanges();
            this.cambiaPerfil();
          }, 500)
          if (_cliente_id) {

            this.clienteSeleccionado_id = _cliente_id;

            for (let x = 0; x < this.clientes.length; x++) {
              if (this.clienteSeleccionado_id == this.clientes[x].id) {
                this.clienteSeleccionado = this.clientes[x];

                if (this.clienteSeleccionado.tipo == "contacto") {
                  this.perfilesFacturacion = this.clienteSeleccionado["perfiles"];
                  this.tipoSeleccionado = "contacto";
                  this.labelSeleccionado = "Clientes"
                } else {
                  this.perfilesFacturacion = this.clienteSeleccionado["clientes"];
                  this.tipoSeleccionado = "cliente";
                  this.labelSeleccionado = "Solicitantes"
                }


                this.changeDetectRef.detectChanges();

              }
            }


          }



        }
      })
    );

    this.subscriptions.push(
      this.appState$.select('direcciones').subscribe(data => {
        var aux = this.clonarArray(this.direccionesSeleccionadas);
        this.buscarSelectores(aux, data);
        this.direccionesSeleccionadas = data;
        this.changeDetectRef.detectChanges();
      })
    );


  }

  options: ContactoModelo[] = [

  ];


  control_autocompletable = new FormControl();
  filteredOptions: any;

  private _filter(_contacto: string): ContactoModelo[] {
    const filterValue = _contacto.toLowerCase();

    return this.options.filter(option => option.firstName.toLowerCase().includes(filterValue));
  }

  displayFn(_contacto: ContactoModelo): string {
    return _contacto && _contacto.firstName ? _contacto.firstName : '';
  }

  temporalConctactoValor: any;

  cargandoBusquedaContacto: boolean = false;


  buscarContactos() {
    var pal = this.temporalConctactoValor;
    this.cargandoBusquedaContacto = true;


    this.http.post(this.getBaseUrl() + "customer/buscar-clientes", { texto_busqueda: pal, c: "sdfklsdj22343423sklfjasfASDFhfjasdf2#$F#423423" }).toPromise()
      .then((data: any) => {

        this.options = data.data;
        this.clientes = data.data; this.options = data.data;
        this.clientes = data.data;
        if (this.clientes && this.clientes.length > 0) {
          this.clienteSeleccionado = this.clientes[0];
          this.cambiaGenerico('cliente');
          setTimeout(() => {
            if (this.perfilesFacturacion && this.perfilesFacturacion.length > 0) {
              this.perfilSeleccionado = this.perfilesFacturacion[0].id;

            }


          }, 500);
        }

        this.cargandoBusquedaContacto = false;
      })
      .catch(e => {
        this.cargandoBusquedaContacto = false;
      });
  }

  buscarSelectores(aux, data) {
    for (var j = 0; j < aux.length; j++) {
      for (var i = 0; i < data.length; i++) {
        if (aux[j].id == data[i].id && aux[j].selected) {
          data[i].selected = true;
        }
      }
    }
  }
  clonarArray(arr) {
    let arre = [];
    for (var i = 0; i < arr.length; i++) {
      arre.push(Object.assign(arr[i], {}));
    }
    return arre;
  }

  abrirConfirmacion() {

  }

  private subsDialog: any;
  abrirDireccion(data): void {
    data.editImages = false;
    const dialogRef = this.dialog.open(DireccionDialog, {
      width: '520px',
      height: '430px',
      data
    });
    this.subscriptions.push(
      this.subsDialog = dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (result.id) {
            this.appState$.dispatch(new EliminarDireccionAction(result))
          } else {

            result["cliente_id"] = this.cliente_id;
            this.appState$.dispatch(new AgregarDireccionAction(result))
          }
        }
      })
    );
  }
  dispara = new EventEmitter<any>();
  abrirDireccionAddImage(data, indice): void {
    data.editImages = true;
    data.eventE = this.dispara;
    var _objx: any;
    this.subscriptions.push(
      this.appState$.select('direcciones').subscribe(_data => {
        data = _data[indice];
        this.dispara.emit(_data[indice])
      }
      ));

    const tamDialog = window.innerWidth >= 1015 ? 1000 : window.innerWidth - 20;

    const dialogRef = this.dialog.open(DireccionDialog, {
      width: tamDialog + 'px',
      height: '500px',
      data
    });
    this.subsDialog = dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.id) {
          this.appState$.dispatch(new EliminarDireccionAction(result))
        } else {

          result["cliente_id"] = this.cliente_id;
          this.appState$.dispatch(new AgregarDireccionAction(result))
        }
      }
    });
  }


  ocultarAcabado: any = false;

  getBannerList() {
    const params: any = {};
    params.limit = 100;
    params.offset = 0;
    this.productDetail.getBannerList(params);
  }
  unidadesMedida: any[] = [{ unidad: 'metros' }, { unidad: 'centimetros' }];
  campos: any = [];
  verx: any;
  detalle: any;
  precioOriginal: any;
  precioUnitario: any;

  getProductdetail() {
    const params: any = {};
    params.id = this.idProductoCarrito || this.id;
    params.cliente_id = this.cliente_id;
    if (localStorage.getItem("cliente_id")) {
      this.cliente_id = localStorage.getItem("cliente_id") || "0";
    } else {
      localStorage.setItem("cliente_id", this.cliente_id || "0");
    }

    this.productDetail.getProductDetails(params);
    this.subscriptions.push(
      this.productDetail.productDetails$.subscribe(detail => {

        if (detail && detail.productImage.length > 0) {
          this.detalle = JSON.parse(JSON.stringify(detail));
          window["detalleP"] = this.detalle;

          if (this.detalle["descuentos"]["campos"])
            this.detalle["descuentos"]["campos"] = JSON.parse(this.detalle["descuentos"]["campos"]);

          this.detalle["subtotal"] = detail.price;
          this.precioOriginal = detail.price;
          this.precioUnitario = detail.price;
          this.campos = this.detalle.productFieldDev;

          setTimeout(() => {
            this.productDetail.productDetails$["price"] = 1000;
            this.changeDetectRef.detectChanges();

          }, 6000);
          for (var i = 0; i < this.campos.length; i++) {
            this.campos[i]["opciones_o"] = JSON.parse(this.campos[i]["opciones"]);
            this.campos[i]["opciones"] = this.buscarDescuentos(this.campos[i]["nombre"], i);
          }

          let medidasProducto = {
            largo: this.detalle.medida_largo,
            alto: this.detalle.medida_alto
          };

          this._medidaAl = parseFloat(medidasProducto.alto.split(".")[0] || 1);
          this._medida2Al = parseFloat(medidasProducto.alto.split(".")[1] || 0);
          this._medidaAn = parseFloat(medidasProducto.largo.split(".")[0] || 1);
          this._medida2An = parseFloat(medidasProducto.largo.split(".")[1] || 0);
          this.nombre_unidad = this.detalle.nombre_unidad || '1';
          this.unidad_medida = this.detalle.unidad_medida;
          switch (this.unidad_medida) {
            case "m":
              this.unidad_medida_label1 = "Metros";
              this.unidad_medida_label2 = "Centrimetros";
              break;
            case "cm":
              this.unidad_medida_label1 = "Centrimetros";
              this.unidad_medida_label2 = "Milimetros";
              break;
            case "pul":
              this.unidad_medida_label1 = "Pulgadas";
              this.unidad_medida_label2 = "Decima de P.";
              break;
            default:

              this.unidad_medida_label1 = "sin u";
              this.unidad_medida_label2 = "sin u";
              break;
          }

          window["campos"] = this.campos;
          window["ver"] = detail;
          this.verx = detail;
          setTimeout(() => {
            this.changeDetectRef.detectChanges();
          }, 2000);
          this.crearFormulario();
          setTimeout(() => {
            this.calcularPrecio();
          }, 500);
          const imageLength = detail.productImage.length;
          this.isActive = [];
          this.isActive[detail.productImage[0].productId] = true;
          for (let i = 0; i < imageLength; i++) {
            if (detail.productImage[i].defaultImage === 1) {
              this.productImageId = detail.productImage[0].productId;
              this.image =
                this.imagePath + '?path=' +
                detail.productImage[i].containerName + '&name=' +
                detail.productImage[i].image +
                '&width=390&height=390';
              this.changeDetectRef.detectChanges();
              setTimeout(() => {
                this.config.observer = true;
                this.changeDetectRef.detectChanges();
              });
            }
          }
          this.cambiaMedida();

          if (this.dataFormulario) {
            let idC = setInterval(() => {
              if (!this.yaPuedeActualizarPreciosEditar) {
                return;
              }
              clearInterval(idC);

              if (this.productoCounteo != 0) {
                document["cambiaCantidad"](this.productoCounteo, this);
                this.cantidad = this.productoCounteo;
                this.detalle.productCount = this.cantidad;

              }


              let fnUnirData = () => {
                let parseados = [];
                this.dataFormulario.forEach(element => {
                  let nombre = element.nombre.toLowerCase();
                  nombre = nombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                  nombre = nombre.replace(/\ /g, "_");
                  if (nombre != "medidas")
                    parseados.push({ 'nombre': nombre, value: element.value });
                  if (this.detalle["medida_fija"] == "variable" && element.nombre == "Medidas") {
                    let medidas = element.value.replace(/(\ |\n|Largo|Alto|m)/g, "");

                    let largo1 = medidas.split("x")[0].split(".")[0];
                    this._medidaAn = parseFloat(largo1);
                    let largo2 = medidas.split("x")[0].split(".")[1];
                    this._medida2An = parseFloat(largo2);

                    let alto1 = medidas.split("x")[1].split(".")[0];
                    this._medidaAl = parseFloat(alto1);
                    let alto2 = medidas.split("x")[1].split(".")[1];
                    this._medida2Al = parseFloat(alto2);
                    this.cambiaMedida();

                  }
                });

                parseados.forEach(element => {
                  vare1: for (let clave in this.productoForm.controls) {
                    this.campos.forEach((el2, elInd) => {
                      if (clave.toLowerCase() == element.nombre && el2.nombre.toLowerCase() == element.nombre) {
                        switch (el2.tipo) {
                          case 'Múltiple':
                            let valorFinal = [];
                            let valorFinalTexto = [];
                            let valoresABuscar = element.value.split(",");
                            valoresABuscar.forEach(elValor => {
                              el2.opciones.forEach(opValue => {
                                if (elValor.trim() == opValue.texto.trim()) {
                                  valorFinal.push(opValue.valor_agregado);
                                  valorFinalTexto.push(opValue.texto);
                                }
                              });
                            });
                            document.getElementById("nombre_" + clave + elInd)["value"] = JSON.stringify(valorFinalTexto);
                            this.productoForm.controls[clave].setValue(JSON.stringify(valorFinal));



                            ; break;
                          default:
                            this.productoForm.controls[clave].setValue(element.value);
                        }
                      }

                    });

                  }
                });


                this.changeDetectRef.detectChanges();

              }
              if (this.productoCounteo != 0)
                fnUnirData();

            }, 300);
          }
        }
      })
    );
  }

  protected getBaseUrl(): string {
    return environment.storeUrl;
  }

  public obtenerDescuentosCliente(params?: any): any {
    let url = this.getBaseUrl();
    const reqOpts: any = {};
    return this.http.get(url + 'product-store/producto-descuento/' + this.id + '/' + this.cliente_id + '', reqOpts);
  }

  public obtenerDescuentosPerfil_y_Grupo(params?: any): any {
    let url = this.getBaseUrl();
    const reqOpts: any = {};
    return this.http.get(url + 'product-store/producto-descuento-perfil-y-grupal/' + this.id + '/' + this.perfilSeleccionado + '', reqOpts);
  }

  buscarDescuentos(descuento, indice) {
    var descuentos = this.detalle["descuentos_originales"] || [];
    for (var j = 0; j < descuentos.length; j++) {
      if (descuentos[j]["nombre"] == descuento) {
        if (descuento != "Descuento por volumen") {



          let deees;
          if (this.detalle["descuentos"]["campos"][j].tipo != "Descuento") {

            deees = JSON.parse(JSON.stringify(this.detalle["descuentos"]["campos"][j]["opciones"]));
          } else {
            deees = [];
          }
          deees.forEach((element, indice) => {
            if (element &&
              descuentos[j]["opciones"][indice].valor_agregado &&
              descuentos[j]["opciones"][indice].valor_agregado.indexOf(",") > -1
            ) {
              let formulasDeOpcion = descuentos[j]["opciones"][indice].valor_agregado.split(",");

              formulasDeOpcion.forEach((element2, indice2) => {
                if (element2.indexOf(">") > -1) {
                  let formulita = element2.split(">");
                  let form1 = formulita[1].trim().split(" ");
                  let formCantidad = form1[0];
                  let formValor = form1[1];
                  if (this.detalle["productCount"] > parseFloat(formCantidad)) {
                    deees[indice]["valor_agregado"] = formValor;
                  }
                } else {

                  deees[indice]["valor_agregado"] = element2;
                }
              });
            }
          });
          return deees;
        }
        return this.detalle["descuentos"]["campos"][j]["opciones"];
      }
    }

    try {

      return JSON.parse(this.campos[indice]["opciones"] || "[]")
    } catch (error) {
      return this.campos[indice]["opciones"]

    }

  }

  stringIfi(str) {
    return JSON.stringify(str);
  }

  descuentos_combinaciones: any[] = [];
  cambiaGenerico(entidad: string) {
    if (this.clienteSeleccionado.tipo == "contacto") {
      this.perfilesFacturacion = this.clienteSeleccionado["perfiles"];
      this.tipoSeleccionado = "contacto";
      this.labelSeleccionado = "Clientes"
      this.tipoClienteContacto = "contacto";
    } else {
      this.perfilesFacturacion = this.clienteSeleccionado["clientes"];
      this.tipoSeleccionado = "cliente";
      this.tipoClienteContacto = "cliente";
      this.labelSeleccionado = "Solicitantes"
    }
    this.cliente_id = this.clienteSeleccionado_id = this.clienteSeleccionado.id;
    this.perfil_id = this.perfilSeleccionado;
    localStorage.setItem("cliente_seleccionado", JSON.stringify([this.clienteSeleccionado]));
    localStorage.setItem("cliente_id", this.cliente_id);
    localStorage.setItem("perfil_id", this.perfil_id);
    localStorage.setItem("cliente_data", JSON.stringify(this.clienteSeleccionado));
    this.subscriptions.push(
      this[entidad == "cliente" ? "obtenerDescuentosCliente" : "obtenerDescuentosPerfil_y_Grupo"]().subscribe(data => {
        this.yaPuedeActualizarPreciosEditar = true;
        if (data["data"] && (data["data"]["campos"] || data["data"].length > 0)) {

          let fnD = (descuentoParam) => {

            let descuentos = this.detalle["descuentos"]["campos"] || [];
            let camposD = (descuentoParam);
            if (entidad == "cliente") {
              descuentos = [];
            } else {



              for (var i = 0; i < descuentos.length; i++) {
                if (descuentos[i].tipoD == camposD[0].tipoD) {
                  descuentos.splice(i, 1);
                  i = i - 1;

                }
              }
            }
            for (let i = 0; i < camposD.length; i++) {
              if (entidad == "cliente")
                camposD[i].tipoD = entidad;
              descuentos.push(camposD[i]);
            }


            for (let i = 0; i < descuentos.length; i++) {
              for (let j = 0; j < camposD.length; j++) {
                if (descuentos[i].nombre == camposD[j].nombre && descuentos[i].tipo != "Descuento") {

                }
              }
            }
            this.detalle["descuentos"]["campos"] = descuentos;
            this.detalle["descuentos_originales"] = JSON.parse(JSON.stringify(descuentos));


            for (var i = 0; i < this.campos.length; i++) {
              this.campos[i]["opciones"] = this.buscarDescuentos(this.campos[i]["nombre"], i);
            }
          }
          if (data["data"].length > 0) {
            let removerLuego = ["perfil", "grupo"];

            data["data"].forEach(elm => {
              let devCampos = JSON.parse(elm["campos"] || "[]") || [];
              if (devCampos.length > 0 && removerLuego.indexOf(devCampos[0].tipoD) != -1) {
                removerLuego = removerLuego.filter(e => e != devCampos[0].tipoD);
              }
              fnD(devCampos);
            });

            removerLuego.forEach(el => {
              let descuentos = this.detalle["descuentos"]["campos"] || [];
              for (let i = 0; i < descuentos.length; i++) {
                if (descuentos[i].tipoD == el) {
                  descuentos.splice(i, 1);
                  i = i - 1;
                }

              }
              this.detalle["descuentos"]["campos"] = descuentos;
            });

          } else {
            fnD(JSON.parse(data["data"]["campos"]));
          }
          this.cambiaMedida();
          this.revisarPrecioBase();
          this.changeDetectRef.detectChanges();
        } else {
          let descuentos = this.detalle["descuentos"]["campos"] || [];
          for (let i = 0; i < descuentos.length; i++) {
            if (entidad == "cliente" && descuentos[i].tipoD) {
              descuentos.splice(i, 1);
              i = i - 1;

            } else if (["perfil", "grupo"].indexOf(descuentos[i].tipoD) != -1) {
              descuentos.splice(i, 1);
              i = i - 1;
            }
          }
          for (var i = 0; i < this.campos.length; i++) {
            this.campos[i]["opciones"] = JSON.parse(JSON.stringify(this.campos[i]["opciones_o"]));
          }
          if (this.detalle["descuentos"]["campos"])
            for (var i = 0; i < this.detalle["descuentos"]["campos"].length; i++) {
              if (this.detalle["descuentos"]["campos"][i].tipoD == entidad) {
                this.detalle["descuentos"]["campos"].splice(i, 1);
                i = i - 1;
              }
            }
          this.cambiaMedida();
          this.revisarPrecioBase();

        }
        this.crearGridDeDescuento();
        this.calcularPrecio();
      })
    );
  }





  cambiaCliente() {
    if (this.clienteSeleccionado.tipo == "contacto") {
      this.perfilesFacturacion = this.clienteSeleccionado["perfiles"];
      this.tipoSeleccionado = "contacto";
      this.labelSeleccionado = "Cliente"
    } else {
      this.perfilesFacturacion = this.clienteSeleccionado["clientes"];
      this.tipoSeleccionado = "cliente";
      this.labelSeleccionado = "Solicitantes"
    }
    this.cliente_id = this.clienteSeleccionado_id = this.clienteSeleccionado.id;
    localStorage.setItem("cliente_id", this.cliente_id);
    localStorage.setItem("cliente_data", JSON.stringify(this.clienteSeleccionado));
    this.subscriptions.push(
      this.obtenerDescuentosCliente().subscribe(data => {
        if (data["data"] && data["data"]["campos"]) {
          let descuentos = this.detalle["descuentos"]["campos"] || [];
          let camposD = JSON.parse(data["data"]["campos"]);
          for (var i = 0; i < descuentos.length; i++) {
            if (descuentos[i].tipoD == "cliente") {
              descuentos.splice(i, 1);
            }
          }
          for (let i = 0; i < camposD.length; i++) {
            camposD[i].tipoD = "cliente";
            descuentos.push(camposD[i]);
          }

          for (let i = 0; i < descuentos.length; i++) {
            for (let j = 0; j < camposD.length; j++) {
              if (descuentos[i].nombre == camposD[j].nombre) {

                for (let op = 0; op < descuentos[i].opciones.length; op++) {
                  let valor1 = parseFloat(descuentos[i].opciones[op].valor_agregado.replace(/\D/g, ""))
                  let valor2 = parseFloat(camposD[j].opciones[op].valor_agregado.replace(/\D/g, ""))
                  if (valor2 < valor1) {
                    descuentos[i].opciones[op].valor_agregado = camposD[j].opciones[op].valor_agregado;
                  }
                }
              }
            }
          }
          this.detalle["descuentos"]["campos"] = descuentos;


          for (var i = 0; i < this.campos.length; i++) {
            this.campos[i]["opciones"] = this.buscarDescuentos(this.campos[i]["nombre"], i);
          }
          this.cambiaMedida();
          this.revisarPrecioBase();
          this.changeDetectRef.detectChanges();
        } else {
          for (var i = 0; i < this.campos.length; i++) {
            this.campos[i]["opciones"] = JSON.parse(JSON.stringify(this.campos[i]["opciones_o"]));
          }
          this.detalle["descuentos"]["campos"] = [];
          this.cambiaMedida();
          this.revisarPrecioBase();
          this.changeDetectRef.detectChanges();
        }
      })
    );
  }

  invokaDescuentosGrupalesPerfil(entidad: string = 'perfil') {
    this.subscriptions.push(
      this[entidad == "cliente" ? "obtenerDescuentosCliente" : "obtenerDescuentosPerfil_y_Grupo"]().subscribe(data => {
        this.yaPuedeActualizarPreciosEditar = true;
        if (data["data"] && (data["data"]["campos"] || data["data"].length > 0)) {

          let fnD = (descuentoParam) => {

            let descuentos = this.detalle["descuentos"]["campos"] || [];
            let camposD = (descuentoParam);
            if (entidad == "cliente") {
              descuentos = [];
            } else {



              for (var i = 0; i < descuentos.length; i++) {
                if (descuentos[i].tipoD == camposD[0].tipoD) {
                  descuentos.splice(i, 1);
                  i = i - 1;

                }
              }
            }
            for (let i = 0; i < camposD.length; i++) {
              if (entidad == "cliente")
                camposD[i].tipoD = entidad;
              descuentos.push(camposD[i]);
            }


            for (let i = 0; i < descuentos.length; i++) {
              for (let j = 0; j < camposD.length; j++) {
                if (descuentos[i].nombre == camposD[j].nombre && descuentos[i].tipo != "Descuento") {

                }
              }
            }
            this.detalle["descuentos"]["campos"] = descuentos;
            this.detalle["descuentos_originales"] = JSON.parse(JSON.stringify(descuentos));


            for (var i = 0; i < this.campos.length; i++) {
              this.campos[i]["opciones"] = this.buscarDescuentos(this.campos[i]["nombre"], i);
            }
          }
          if (data["data"].length > 0) {
            let removerLuego = ["perfil", "grupo"];

            data["data"].forEach(elm => {
              let devCampos = JSON.parse(elm["campos"] || "[]") || [];
              if (devCampos.length > 0 && removerLuego.indexOf(devCampos[0].tipoD) != -1) {
                removerLuego = removerLuego.filter(e => e != devCampos[0].tipoD);
              }
              fnD(devCampos);
            });

            removerLuego.forEach(el => {
              let descuentos = this.detalle["descuentos"]["campos"] || [];
              for (let i = 0; i < descuentos.length; i++) {
                if (descuentos[i].tipoD == el) {
                  descuentos.splice(i, 1);
                  i = i - 1;
                }

              }
              this.detalle["descuentos"]["campos"] = descuentos;
            });

          } else {
            fnD(JSON.parse(data["data"]["campos"]));
          }
          this.cambiaMedida();
          this.revisarPrecioBase();
          this.changeDetectRef.detectChanges();
        } else {
          let descuentos = this.detalle["descuentos"]["campos"] || [];
          for (let i = 0; i < descuentos.length; i++) {
            if (entidad == "cliente" && descuentos[i].tipoD) {
              descuentos.splice(i, 1);
              i = i - 1;

            } else if (["perfil", "grupo"].indexOf(descuentos[i].tipoD) != -1) {
              descuentos.splice(i, 1);
              i = i - 1;
            }
          }
          for (var i = 0; i < this.campos.length; i++) {
            this.campos[i]["opciones"] = JSON.parse(JSON.stringify(this.campos[i]["opciones_o"]));
          }
          if (this.detalle["descuentos"]["campos"])
            for (var i = 0; i < this.detalle["descuentos"]["campos"].length; i++) {
              if (this.detalle["descuentos"]["campos"][i].tipoD == entidad) {
                this.detalle["descuentos"]["campos"].splice(i, 1);
                i = i - 1;
              }
            }
          this.cambiaMedida();
          this.revisarPrecioBase();

        }
        this.crearGridDeDescuento();
        this.calcularPrecio();
      })
    );
  }

  cambiaPerfil() {
    this.perfilesFacturacion = this.clienteSeleccionado["perfiles"];
    this.cliente_id = this.clienteSeleccionado_id = this.clienteSeleccionado.id;
    localStorage.setItem("cliente_id", this.cliente_id);
    localStorage.setItem("cliente_data", JSON.stringify(this.clienteSeleccionado));
    this.invokaDescuentosGrupalesPerfil();
  }
  cambiaCantidad(event) {
    this.cantidad = event;
    this.detalle["productCount"] = this.cantidad;
    this.productoForm.controls["cantidad"].setValue(this.cantidad);
    this.calcularPrecio();
  }
  traeDescuentos = false;
  ngAfterViewInit() {
    this.getProductdetail();

    let ii = setInterval(() => {
      if (this.detalle && this.clienteSeleccionado && this.detalle.descuentos) {
        this.perfilSeleccionado = localStorage.getItem("perfil_id") || '';
        this.cambiaGenerico('cliente');
        if (this.perfilSeleccionado) {
          setTimeout(() => {
            this.cambiaPerfil();
          }, 1000);
        }
        clearInterval(ii);
      }
    }, 300)
    this.config = {
      observer: false,
      direction: 'vertical',
      autoHeight: true,
      autoplay: true,
      spaceBetween: 10,
      keyboard: true,
      navigation: true,
      grabCursor: true,
      pagination: false,
      loop: false,
      preloadImages: false,
      lazy: true,
      watchSlidesVisibility: true,
      breakpoints: {
        480: {
          slidesPerView: 2
        },
        600: {
          slidesPerView: 3
        }
      }

    };
    this.config2 = {
      slidesPerView: 3,
      spaceBetween: 50,
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,
      loop: true,
      preloadImages: false,
      lazy: true,
      autoplay: false,
      speed: 500,
      effect: 'slide',
      breakpoints: {
        320: {
          slidesPerView: 1
        },
        480: {
          slidesPerView: 2
        },
        600: {
          slidesPerView: 3
        },
        960: {
          slidesPerView: 4
        },
        1280: {
          slidesPerView: 5
        },
        1500: {
          slidesPerView: 6
        }
      }
    };
    this.configuration = {
      observer: false,
      slidesPerView: 4,
      spaceBetween: 10,
      keyboard: true,
      navigation: true,
      grabCursor: true,
      pagination: false,
      loop: false,
      preloadImages: false,
      lazy: true,
      autoplay: false,
      watchSlidesVisibility: true,
      breakpoints: {
        480: {
          slidesPerView: 2
        },
        600: {
          slidesPerView: 3
        }
      }
    };
  }

  public selectImage(image, i) {
    this.productImageId = image.productId;
    this.isActive = [];
    this.isActive[image.productId] = true;
    this.image =
      this.imagePath + '?path=' +
      image.containerName + '&name=' +
      image.image +
      '&width=390&height=390';
    this.changeDetectRef.detectChanges();
    this.zoomImage =
      this.imagePath + '?path=' +
      image.containerName + '&name=' +
      image.image +
      '&width=660&height=660';
  }

  public onMouseMove(e) {
    if (window.innerWidth >= 1280) {
      let image, offsetX, offsetY, x, y, zoomer;
      image = e.currentTarget;
      offsetX = e.offsetX;
      offsetY = e.offsetY;
      x = (offsetX / image.offsetWidth) * 100;
      y = (offsetY / image.offsetHeight) * 100;
      if (this.zoomImage) {
        zoomer = this.zoomViewer.nativeElement.children[0];
      }
      if (zoomer) {
        zoomer.style.backgroundPosition = x + '% ' + y + '%';
        zoomer.style.display = 'block';
        zoomer.style.height = image.height + 'px';
        zoomer.style.width = image.width + 'px';
      }
    }
  }

  public onMouseLeave(event) {
    this.zoomViewer.nativeElement.children[0].style.display = 'none';
  }

  public openZoomViewer() {
    this.dialog.open(ProductZoomComponent, {
      data: this.zoomImage,
      panelClass: 'zoom-dialog'
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
    this.subscriptions.forEach(each => {
      each.unsubscribe();
    });
    if (this.subsDialog)
      this.subsDialog.unsubscribe();
    this.clienteSeleccionado = null;

  }
  public productoForm: FormGroup;
  disenoForm: FormGroup;



  crearFormulario() {
    let _group = {}
    this.campos.forEach(($valor, $indice) => {
      if ($valor.tipo == "Único")
        _group[$valor["nombre"]] = new FormControl($valor["opciones"][0]["valor_selecionado"]);
      else
        _group[$valor["nombre"]] = new FormControl('');
    });
    _group["_medidaAn"] = new FormControl('');
    _group["_medida2An"] = new FormControl('');
    _group["_medidaAl"] = new FormControl('');
    _group["_medida2Al"] = new FormControl('');
    _group["cantidad"] = new FormControl('1');
    _group["control_autocompletable"] = this.control_autocompletable;

    this.productoForm = new FormGroup(_group);
    this.disenoForm = new FormGroup({});

    this.filteredOptions = this.control_autocompletable.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filter(name) : this.options.slice())
      );
    window["productoForm"] = this.productoForm;
  }

  visible($campo: any) {

    if ($campo.visualizacion) {
      let _retorno = true;
      let _json = JSON.parse($campo.visualizacion);
      _json.forEach($element => {
        for (let _key in $element) {
          let _operacion = eval(('\'' + this.productoForm.get(_key).value + '\'' || '\'\'') + "" + $element[_key]);
          try {
            if (!_operacion) _retorno = false;
          } catch (error) {
            //console.error(error);
            _retorno = false;
          }
        }
      });
      return _retorno;

    } else {
      return true;
    }
  }





  public buscarPrecioCampo(nombreCampo) {
    for (var i = 0; i < this.campos.length; i++) {
      if (this.campos[i].nombre == nombreCampo) {
        let indiceSeleccionado = 0;
        let valueS = this.productoForm.get(nombreCampo).value;
        if (valueS) {
          for (let j = 0; j < this.campos[i].opciones.length; j++) {
            if (this.campos[i].opciones[j].valor_selecionado == valueS) {
              return this.campos[i].opciones[j].valor_agregado;
            }
          }
        } else {
          return this.campos[i].opciones[0].valor_agregado;
        }
      }
    }
    return "";
  }

  formatearAgregado(nombreCampo) {
    for (var i = 0; i < this.campos.length; i++) {
      if (this.campos[i].nombre == nombreCampo) {
        let indiceSeleccionado = 0;
        let valueS = this.productoForm.get(nombreCampo).value;
        if (valueS) {
          for (let j = 0; j < this.campos[i].opciones.length; j++) {
            if (this.campos[i].opciones[j].valor_selecionado == valueS) {

              return "" + (("" + parseFloat(this.campos[i].opciones[j].valor_agregado).toFixed(2)))

            }
          }
        }
      }
    }
    return "";



  }
  /*
 
  */

  revisarPrecioBase() {
    if (!this.detalle["productCount"]) this.detalle["productCount"] = 1;

    let precioProd = this.precioOriginal;
    let totalm2: number =
      parseFloat(this.fixearCantidad(this.ancho * this.alto)) *
      (this.detalle["productCount"]);
    //alert(this.detalle["productCount"]+":"+totalm2)
    const campos = this.detalle["descuentos"]["campos"] || [];
    let coincidenciaEncontrada = false;
    let pasa = false;
    for (let i = 0; i < campos.length; i++) {
      if (campos[i].tipo == "Descuento") continue;
      let formula;
      //this.buscarDescuentos(this.campos[i]["nombre"], i);


      if (campos[i].tipo == "Formula") {
        pasa = true;
        //m2 > 25 entonces precio_producto= 100
        formula = campos[i]["opciones"][0].valor_agregado + ":null";
        //remplazo m2
        formula = formula.replace(/m2/g, totalm2);
        //remplazo entonces
        formula = formula.replace(/entonces/g, "?");

        //remplazo precio del producto
        formula = formula.replace(/precio_producto/g, "precioProd");

        //TODO separa los tipos de formula, pero es este caso se puden juntar las 2

        try {

          eval(formula)
        } catch (error) {
          formula = formula.replace(/:null/g, "");
          eval(formula)
        }
        this.precioUnitario = precioProd;
        this.changeDetectRef.detectChanges();
      } else if (campos[i].tipo == "precio_combinado") {
        // Logic moved to calcularPrecio. Leaving this empty to prevent fall-through to the next else-if which modifies options.
      } else if (campos[i]["nombre"] != "Descuento por volumen") {
        campos[i]["opciones"] = this.buscarDescuentos(campos[i]["nombre"], i);
        for (let i2 = 0; i2 < this.campos.length; i2++) {
          if (this.campos[i2].nombre == campos[i].nombre) {
            //this.campos[i2].opciones=campos[i].opciones; 

          }
        }
        for (var ii = 0; ii < this.campos.length; ii++) {

          //  this.campos[ii]["opciones"] = this.buscarDescuentos(this.campos[ii]["nombre"], ii);
          //this.campos[ii]["opciones"];
          if (this.campos[ii].nombre == campos[i].nombre) {


            for (let xx = 0; xx < this.campos[ii]["opciones"].length; xx++) {
              this.campos[ii]["opciones"][xx]["valor_agregado"] = campos[i]["opciones"][xx]["valor_agregado"];
            }
          }
        }
        this.changeDetectRef.detectChanges();
        // this["campos"][i]=campos[i];


      }
    }
    this.coincide = coincidenciaEncontrada;
    if (!pasa && !coincidenciaEncontrada) {
      this.precioUnitario = precioProd;
    }
    this.changeDetectRef.detectChanges();
  }
  //m2 > 0 20, m2 > 10 15, m2 > 20 13, m2 > 50 10, m2 > 100 9
  //m2 > 0 35, m2 > 10 26, m2 > 20 23, m2 > 50 16, m2 > 100 13

  //totalm2 > 0 20, totalm2 > 10 15, totalm2 > 20 13, totalm2 > 50 10, totalm2 > 100 9
  //totalm2 > 0 35, totalm2 > 10 26, totalm2 > 20 23, totalm2 > 50 16, totalm2 > 100 13

  //Suaje, Suajado
  _obtenerFormulaDescuento(str): number {
    let _formulas = str.split(",");
    let valor_retorno = 0;
    _formulas.forEach((element, index) => {
      if (element.indexOf("m2") > -1) {
        let totalm2: number =
          parseFloat(this.fixearCantidad(this.ancho * this.alto));
        let cantidad = element.split(">")[1].trim().split(" ")[0];
        let precio = element.split(">")[1].trim().split(" ")[1];
        if (totalm2 > parseFloat(cantidad))
          valor_retorno = parseFloat(precio);
      }
      if (element.indexOf("totalm2") > -1) {
        let totalm2: number =
          parseFloat(this.fixearCantidad(this.ancho * this.alto)) * (this.detalle["productCount"]);
        let cantidad = element.split(">")[1].trim().split(" ")[0];
        let precio = element.split(">")[1].trim().split(" ")[1];
        if (totalm2 > parseFloat(cantidad))
          valor_retorno = parseFloat(precio);
      }
      if (element.indexOf("n") > -1) {
        let cantidadN: number =
          parseFloat(this.fixearCantidad(1)) * (this.detalle["productCount"]);
        let cantidad = element.split(">")[1].trim().split(" ")[0];
        let precio = element.split(">")[1].trim().split(" ")[1];
        if (cantidadN > parseFloat(cantidad))
          valor_retorno = parseFloat(precio);
      }
    });

    return valor_retorno;
  }

  coincide = false;
  precioFinalDescuento = 0;
  descuentosCombinadosAplicados: any = null;
  calcularPrecio() {
    this.precioFinalDescuento = 0; // Reset for new calculation coverage
    this.descuentosCombinadosAplicados = null; // Reset previous match
    if (!this.detalle["productCount"]) this.detalle["productCount"] = 1;
    this.revisarPrecioBase();
    let precioBaseUnitario = this.precioUnitario;
    let _operaciones = parseFloat(this.precioUnitario.toString());

    //alert("12=>"+_price)
    let conteo = 0;
    let multiplicador = 1;
    let aux_cantidad = parseFloat(this.detalle["minima_cantidad"]);
    if (1 / this.detalle["productCount"] > 1)
      multiplicador = multiplicador * (1 / this.detalle["productCount"]);
    else if (multiplicador)
      multiplicador = 1;

    let redondearSobrante = false;
    let precioUnitarioSinDescuento = this.precioUnitario;
    let agregadoAlFinal = 0;

    let camposDescuentosValidos = 0;
    let camposDescuentosEncontrados = 0;
    let precioFinalDescuento = 0;


    let tieneSobrante = this.detalle["productCount"] % 1 == 0 ? false : true;
    //revisar otras formulas
    if ((this.detalle["descuentos"]["campos"] || []).length > 0) {
      // Limpiar descuentos aplicados y resetear estado
      this.descuentosAplicados = [];
      this.detalle["descuentos"]["campos"].forEach(d => d.aplicado = false);

      this.detalle["descuentos"]["campos"].forEach(element => {
        if (element.tipo == "Descuento") {
          let camposDescuentosValidos = 0;
          let camposDescuentosEncontrados = 0;

          element.campos.forEach(elementCampo => {
            let _dNombre = elementCampo.nombre.toLowerCase().replace(/\ /gi, "_");
            _dNombre = _dNombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            let _dValor = elementCampo.value;

            let formCampo = this.productoForm.controls[_dNombre];
            let campoNN = this.buscarCampo(_dNombre);
            if (formCampo) {
              if (campoNN.tipo == "Múltiple" && _dValor == "Ninguno") {


                _dValor = "";
              }
              camposDescuentosValidos++;
              let valorActualCampo = formCampo.value;
              if (campoNN.tipo == "Múltiple") {
                let indice = this.buscarCampoIndice(_dNombre);
                let elementoDOM = document.getElementById(`nombre_${_dNombre}${indice}`);

                if (elementoDOM) {
                  valorActualCampo = elementoDOM["value"];
                  // Parse actual value into array
                  let arrValorActual = JSON.parse(valorActualCampo || "[]");

                  // Parse expected value into array
                  // _dValor comes as a comma-separated string from the discount configuration
                  let arrValorEsperado = _dValor.split(",").map(s => s.trim()).filter(s => s !== "" && s !== "Ninguno");

                  // Normalizar a minúsculas para comparación case-insensitive
                  arrValorActual = arrValorActual.map(v => v.toLowerCase().trim());
                  arrValorEsperado = arrValorEsperado.map(v => v.toLowerCase().trim());

                  // Sort both arrays to ensure order independence
                  arrValorActual.sort();
                  arrValorEsperado.sort();

                  // Compare arrays strictly - deben tener exactamente los mismos elementos
                  if (JSON.stringify(arrValorActual) === JSON.stringify(arrValorEsperado)) {
                    camposDescuentosEncontrados++;
                  } else {
                  }
                }

              } else {
                // Original logic for non-multiple fields
                if (_dValor == valorActualCampo) {
                  camposDescuentosEncontrados++;
                } else {
                }
              }

            }
          });
          if (camposDescuentosEncontrados == camposDescuentosValidos && camposDescuentosValidos > 0

          ) {
            element.aplicado = true;

            // Trasladar el descuento a descuentosAplicados
            let descuentoAplicado = {
              ...element, // Copiar todas las propiedades del descuento
              precioFinal: element.precioFinal || null // Asegurar que tenga el campo precioFinal
            };

            this.descuentosAplicados.push(descuentoAplicado);

            if (this.precioFinalDescuento != 0) {
              precioFinalDescuento = element.precioFinal;
              this.precioFinalDescuento = precioFinalDescuento < this.precioFinalDescuento ?
                precioFinalDescuento : this.precioFinalDescuento;
            } else {
              precioFinalDescuento = element.precioFinal;
              this.precioFinalDescuento = precioFinalDescuento;
            }
          }
        } else if (element.tipo == 'precio_combinado') {
          // Logic for precio_combinado
          let coincidencia = true;
          if (element.opciones && element.opciones.length > 0) {
            for (let op of element.opciones) {
              // Normalize naming
              let _dNombre = (op.titulo || op.nombre || '').toLowerCase().replace(/\ /gi, "_");
              _dNombre = _dNombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

              let formCampo = this.productoForm.controls[_dNombre];
              // If field doesn't exist in form, we can't match it (or maybe it's optional? assuming required for now)
              if (!formCampo) {
                // Try finding by searching in this.campos if the name is different
                let found = false;
                for (let c of this.campos) {
                  let cName = c.nombre.toLowerCase().replace(/\ /gi, "_").normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                  if (cName === _dNombre) {
                    formCampo = this.productoForm.controls[c.nombre];
                    found = true;
                    break;
                  }
                }
                if (!found) {
                  coincidencia = false;
                  break;
                }
              }

              let valorActual = formCampo.value;

              // Handle Multiple type
              if (op.tipo == 'Múltiple') {
                console.log("mariadelpilar")
                // Start similar logic to retrieving multiple values
                let indice = this.buscarCampoIndice(_dNombre);
                let elementoDOM = document.getElementById(`nombre_${_dNombre}${indice}`);
                if (elementoDOM) {
                  let rawVal = elementoDOM["value"]; // This is usually a JSON string of selected texts
                  let currentArr = JSON.parse(rawVal || "[]").map(s => s.trim().toLowerCase());
                  let targetArr = (op.valor || []).map(s => s.trim().toLowerCase());

                  currentArr.sort();
                  targetArr.sort();

                  if (JSON.stringify(currentArr) !== JSON.stringify(targetArr)) {
                    coincidencia = false;
                    break;
                  }
                } else {
                  coincidencia = false;
                  break;
                }
              } else {
                // Simple comparison
                // Ensure we compare apples to apples. op.valor_selecionado vs form value
                // Sometimes op.valor_selecionado is what we want.
                let targetVal = (op.valor_selecionado || op.valor || '').toString().toLowerCase().trim();
                let currentVal = (valorActual || '').toString().toLowerCase().trim();

                if (targetVal !== currentVal) {
                  coincidencia = false;
                  break;
                }
              }
            }
          }

          if (coincidencia) {
            element.aplicado = true;
            this.descuentosCombinadosAplicados = { ...element }; // Store COPY of discount object

            // Apply price
            if (element.precio) {
              // Prioritize this price? Or compare with others? 
              // Usually combined price is specific and aggressive. Let's start by treating it as a candidate for best price
              if (this.precioFinalDescuento != 0) {
                let p = parseFloat(element.precio);
                this.precioFinalDescuento = p < this.precioFinalDescuento ? p : this.precioFinalDescuento;
                precioFinalDescuento = this.precioFinalDescuento; // Update local variable
              } else {
                this.precioFinalDescuento = parseFloat(element.precio);
                precioFinalDescuento = this.precioFinalDescuento; // Update local variable
              }
            }
          } else {
            element.aplicado = false; // Reset if not matching
            if (this.descuentosCombinadosAplicados === element) {
              this.descuentosCombinadosAplicados = null;
            }
          }
        }
      });

      // Override with Combined Price if active, ensuring it takes precedence over standard 'lowest wins' logic
      if (this.descuentosCombinadosAplicados) {
        this.precioFinalDescuento = parseFloat(this.descuentosCombinadosAplicados.precio);
        precioFinalDescuento = this.precioFinalDescuento;
      }
    }


    if (!this.coincide)
      for (let _x in this.productoForm.controls) {
        conteo++;
        let _campo = this.buscarCampo(_x);
        switch (_campo["tipo"]) {
          case 'Único':
            /*if (precioFinalDescuento > 0) {//Si hay un descuento seleccionable
              break;
            }*/
            let _opcionesC = _campo['opciones'];
            for (var j = 0; j < _opcionesC.length; j++) {
              //console.loc()


              if (!_opcionesC[j]["valor_agregado"]) {
                continue;
              }


              let _oper = _operaciones;
              if (_opcionesC[j]["valor_selecionado"] == this.productoForm.controls[_x].value) {
                if (_opcionesC[j]["valor_agregado"].split(",").length != 1) {
                  _oper += this._obtenerFormulaDescuento(_opcionesC[j]["valor_agregado"]);
                } else {


                  switch (this._obtenerOperacion(_opcionesC[j]["valor_agregado"])) {
                    case "suma": ;
                    case "resta":
                      //_operaciones=`((${_operaciones})+(${_opcionesC[j]["valor_agregado"]}))`;
                      _oper += parseFloat(_opcionesC[j]["valor_agregado"].toString());
                      break;
                    case "multiplicacion":
                      _oper *= parseFloat(_opcionesC[j]["valor_agregado"].toString()
                        .replace(/\**|x*|\ */g, "")
                      );
                      break;
                    case "porcentaje":
                      _oper *= 1 + parseFloat(_opcionesC[j]["valor_agregado"].toString()
                        .replace(/\%|\ $/g, "")
                      ) / 100;
                      ;
                  }
                }

                if (_opcionesC[j]["largo"] && _opcionesC[j]["alto"]) {
                  this.extraerMedidas(_opcionesC[j]["largo"], _opcionesC[j]["alto"])

                }

                _oper = _oper - _operaciones;
                _oper *= multiplicador;
                _operaciones += _oper;
                precioUnitarioSinDescuento += _oper;
              }
            }
            ; break;
          case 'Múltiple':
            /*if (precioFinalDescuento > 0) {
              break;
            }*/
            let agregarAlFinal = false;
            try {
              let _getJson = JSON.parse(_campo["valor"]);
              agregarAlFinal = _getJson["agregarAlFinal"] || false;
            } catch (error) {

            }


            let opciones = [];
            if (document.getElementById(_x + (conteo - 1)))
              opciones = JSON.parse(document.getElementById(_x + (conteo - 1))["value"] || "[]");



            let _oper = _operaciones;
            for (let mi = 0; mi < opciones.length; mi++) {
              if (opciones[mi].split(",").length != 1) {
                let rest = parseFloat(this._obtenerFormulaDescuento(opciones[mi]).toString());
                if (!agregarAlFinal)
                  _oper += rest;
                else
                  agregadoAlFinal += rest;

              } else {

                switch (this._obtenerOperacion(opciones[mi])) {
                  case "suma": ;
                  case "resta":
                    let opee = parseFloat(opciones[mi].toString());
                    if (!agregarAlFinal)
                      _oper += opee;
                    else
                      agregadoAlFinal += opee;
                    break;
                  case "multiplicacion":
                    let opee2 = parseFloat(opciones[mi].toString()
                      .replace(/\**|x*|\ */g, ""));
                    if (!agregarAlFinal) {
                      _oper *= opee2;
                    } else {
                      agregadoAlFinal += opee;
                    }
                    break;
                  case "porcentaje":
                    let opee3 = 1 + parseFloat(opciones[mi].toString()
                      .replace(/\%|\ $/g, "")) / 100;
                    _oper *= opee3;

                    ;
                }
              }



            }
            _oper = _oper - _operaciones;
            _oper *= multiplicador;
            _operaciones += _oper;
            precioUnitarioSinDescuento += _oper;

            ; break;
          case 'DescuentoXVolumen':
            /*if (precioFinalDescuento > 0) {
              break;
            }*/

            let aux_operaciones = _operaciones;

            try {
              if (!redondearSobrante) {
                let _getJson = JSON.parse(_campo["valor"]);
                redondearSobrante = _getJson["redondearSobrante"] || false;
              }
            } catch (error) {

            }

            let xxxx = 1 / 0;

            if (this.detalle.descuentos.campos && this.detalle.descuentos.campos.length)
              for (let i = 0; i < this.detalle.descuentos.campos.length; i++) {
                let valArray = this.detalle.descuentos.campos[i];
                valArray["opciones"][0].valor_agregado = valArray["opciones"][0].valor_agregado.toLowerCase();
                switch (valArray["tipo"]) {
                  case "DescuentoXVolumen":
                    let cantidad = this.cantidad || 1;
                    let condicionalCantidad = valArray["opciones"][0].valor_agregado.split(">=")[1].trim().split(" ")[0];
                    let campo_c = "";
                    let campo_v = "";
                    let ope = "";
                    let form_value = "";
                    if (valArray["opciones"][0].valor_agregado.search(/\ si\ /g) + 1) {
                      campo_c = valArray["opciones"][0].valor_agregado.split('\ si\ ')[1];
                      //campo_c=campo_c.replace(/\ /g,'');
                      ope = campo_c.search(/\!\=/g) + 1 > 0 ? '!=' : "=";
                      campo_v = campo_c.split(ope)[1].replace(/\ /g, '');
                      campo_c = campo_c.split(ope)[0].replace(/(^ *)|(\ *$)/g, '').replace(/ /g, '_');
                      form_value = (this.productoForm.controls[campo_c].value.toString()).toLowerCase().replace(/\ /g, '');
                    }


                    if (
                      parseFloat(cantidad.toString()) >= parseFloat(condicionalCantidad)
                    ) {

                      if (!campo_c) {
                        _operaciones = aux_operaciones;
                        let descuento = 1 - parseFloat(valArray["opciones"][0].valor_agregado.split(">=")[1].trim().split(" ")[1].replace(/\%/g, "")) / 100;
                        _operaciones = _operaciones * descuento;
                      } else if (campo_c) {

                        if (ope == "!=" && form_value != campo_v) {
                          _operaciones = aux_operaciones;
                          let descuento = 1 - parseFloat(valArray["opciones"][0].valor_agregado.split(">=")[1].trim().split(" ")[1].replace(/\%/g, "")) / 100;

                          _operaciones = _operaciones * descuento;
                        }


                        if (ope == "=" && form_value == campo_v) {
                          _operaciones = aux_operaciones;
                          let descuento = 1 - parseFloat(valArray["opciones"][0].valor_agregado.split(">=")[1].trim().split(" ")[1].replace(/\%/g, "")) / 100;

                          _operaciones = _operaciones * descuento;
                        }

                      }
                      //alert(_operaciones);

                    }
                    break;
                }

              }
            break;
          case 'precio_combinado':
            let opcionesCombinadas = this.detalle["descuentos"]["campos"].find(campo => campo.tipo === 'precio_combinado');
            if (opcionesCombinadas) {
              let coincide = true;
              for (let j = 0; j < opcionesCombinadas.opciones.length; j++) {
                let nombreCampo = opcionesCombinadas.opciones[j]["nombre"];
                let valorSeleccionado = opcionesCombinadas.opciones[j]["valor_selecionado"];
                if (this.productoForm.controls[nombreCampo].value != valorSeleccionado) {
                  coincide = false;
                  break;
                }
              }
              if (coincide) {
                alert("coincide");
                this.precioUnitario = parseFloat(opcionesCombinadas["precio"]);
                this.changeDetectRef.detectChanges();
              }
            }
            break;
        }

      }

    this.precioUnitario = precioFinalDescuento == 0 ? Math.round(_operaciones) : precioFinalDescuento;
    //this.precioUnitario = precioFinalDescuento==0? (_operaciones):precioFinalDescuento;
    let totalm2 = parseFloat(this.fixearCantidad(this.ancho * this.alto));

    if (this.detalle.medida_fija == 'fija' || this.detalle.ignorar_medida_metrica == "1") {
      totalm2 = 1;
    }
    //_operaciones=parseFloat(""+(parseFloat(eval(_operaciosnes))*this.detalle["productCount"])).toFixed(2);
    //_operaciones=parseFloat(eval(_operaciones)).toFixed(2);



    //_operaciones=(parseFloat(_operaciones)*this.cantidad)+"";
    let sobrante = this.detalle["productCount"] % 1;
    if (this.detalle["productCount"] > 1)
      this.detalle["productCount"] = this.detalle["productCount"] - sobrante;
    this.detalle["subtotal"] = this.precioUnitario * this.detalle["productCount"] * totalm2;
    if (tieneSobrante && redondearSobrante && this.detalle["productCount"] >= 1) {
      this.detalle["subtotal"] += (precioUnitarioSinDescuento * aux_cantidad) * ((sobrante) / aux_cantidad);
    }
    this.detalle["subtotal"] += agregadoAlFinal;
    //this.detalle["subtotal"]=this.parseoParaFactura(this.detalle["subtotal"]);
    //this.detalle.descuentoT=(this.precioOriginal*this.detalle["productCount"]* totalm2)-(precioBaseUnitario* this.detalle["productCount"]* totalm2);
    this.detalle.descuentT = this.detalle.descuentT || 0;

    // Asignar precioFinal a descuentos aplicados que no lo tengan
    this.descuentosAplicados.forEach(descuento => {
      if (!descuento.precioFinal || descuento.precioFinal <= 0) {
        descuento.precioFinal = this.precioUnitario;
      }
    });

    if (this.descuentosCombinadosAplicados) {
      this.descuentosCombinadosAplicados.precioOriginal = Math.round(_operaciones);
    }
  }

  revisarCheckeo(str: string, id: string, valor: string) {
    id = 'nombre_' + id;
    if (!document.getElementById(id))
      return false;

    let elementValue = document.getElementById(id)["value"] || "[]";
    let x: any[] = JSON.parse(elementValue);
    if (x.indexOf(str) != -1) {
      return true;
    } else {
      return false;
    }
  }

  cambiaOpcionMultiple(checked, opcionTexto, id, ops) {


    let opciones = JSON.parse(document.getElementById(id)["value"] || "[]");
    let opcionesN = JSON.parse(document.getElementById("nombre_" + id)["value"] || "[]");
    if (!checked) {

      for (let i = 0; i < opcionesN.length; i++) {
        if (opcionTexto == opcionesN[i]) {
          opcionesN.splice(i, 1);
          opciones.splice(i, 1);

        }
      }
    } else {

      opciones.push(ops);
      opcionesN.push(opcionTexto)
    }
    document.getElementById(id)["value"] = JSON.stringify(opciones);
    document.getElementById(`nombre_${id}`)["value"] = JSON.stringify(opcionesN);
    this.calcularPrecio();
  }

  obtenerValoresdeCampoMultiplo(nombre_campo, indice) {
    let opciones = [];
    if (document.getElementById(`nombre_${nombre_campo + indice}`)) {
      try {
        opciones = JSON.parse(document.getElementById(`nombre_${nombre_campo + indice}`)["value"]);

      } catch (error) {
        opciones = [];
      }
    }
    let cad = "";
    for (let i = 0; i < opciones.length; i++) {
      cad = cad + opciones[i] + ", ";
    }
    if (opciones.length == 0) {
      cad = "Ninguno";
      return cad;
    } else
      return cad.substr(0, cad.length - 2);
  }
  descuentosCliente: any[] = [];
  descuentosPerfil: any[] = [];
  descuentosGrupo: any[] = [];

  visibilidadDescuentos = {
    cliente: false,
    perfil: false,
    grupo: false
  };

  mostrarV(str, val) {
    if (this.visibilidadDescuentos.hasOwnProperty(str)) {
      this.visibilidadDescuentos[str] = val;
    }
  }

  hasAppliedDiscounts(): boolean {
    if (!this.gridDeDescuento) return false;
    for (let group of this.gridDeDescuento) {
      if (group.descuentos) {
        for (let des of group.descuentos) {
          if (des.aplicado) return true;
        }
      }
    }
    return false;
  }

  gridDeDescuento: any[] = [];
  descuentosAplicados: any[] = [];

  crearGridDeDescuento() {
    this.descuentosCliente = [];
    this.descuentosPerfil = [];
    this.descuentosGrupo = [];

    if (!this.detalle || !this.detalle.descuentos || !this.detalle.descuentos["campos"])
      return [];

    /* if(!this.detalle.descuentos.campos)
      return [] */

    let descuentos = this.detalle.descuentos;

    descuentos["campos"].forEach(descuentoEl => {
      /* if(descuentoEl.tipo=="Descuento"){ */
      switch (descuentoEl.tipoD) {
        case "cliente":
          this.descuentosCliente.push(descuentoEl);
          break;
        case "perfil":
          this.descuentosPerfil.push(descuentoEl);
          break;
        case "grupo":
          this.descuentosGrupo.push(descuentoEl);
          break;
      }
      /* }else{

      } */
    });

    let result = [];

    if (this.descuentosCliente.length > 0) {
      result.push({
        tipoD: "cliente",
        descuentos: this.descuentosCliente
      });
    }
    if (this.descuentosPerfil.length > 0) {

      result.push({
        tipoD: "perfil",
        descuentos: this.descuentosPerfil
      });
    }
    if (this.descuentosGrupo.length > 0) {

      result.push({
        tipoD: "grupo",
        descuentos: this.descuentosGrupo
      })
    }

    this.gridDeDescuento = result;

  }

  buscarPrecioOriginal(strTitulo, strOpcion, obj) {
    if (!this.detalle || !this.detalle.descuentos)
      return "";
    for (let x = 0; x < this.campos.length; x++) {
      if (this.campos[x].titulo == strTitulo) {
        if (this.campos[x].opciones) {

          for (let j = 0; j < this.campos[x].opciones_o.length; j++) {
            if (this.campos[x].opciones_o[j].texto == strOpcion) {
              return this.campos[x].opciones_o[j].valor_agregado;
            }
          }
        }
      }
    }
    return "";
  }

  filtrarDescuentosVisuales(descuentos) {
    let cadRespuesta = "";
    let arrCad = [];
    let descartados = [
      "Observaciones", "observaciones", "Medidas", "Medidas"
    ];
    descuentos.forEach(element => {
      if (descartados.indexOf(element.nombre) == -1) {
        arrCad.push(` ${element.nombre}:<B>${element.value}</B>`);
      }
    });
    return arrCad.join(",");
  }

  esPrecioValido(valor: any): boolean {
    if (valor === null || valor === undefined || valor === '') return false;
    // Si contiene letras que no son parte de una fórmula simple, asumimos que no es precio directo para pipe
    // Pero pPrecios podría esperar solo números.
    // Vamos a checar si es numérico
    const str = valor.toString().trim();
    // Si es formula (contiene > o < o letras), no es precio simple
    if (str.includes('>') || str.includes('<') || /[a-zA-Z]/.test(str)) {
      return false;
    }
    return !isNaN(parseFloat(str));
  }


  _obtenerOperacion(str: any): string {

    let cad = str.toString().trim();

    if (new RegExp(/^\*/g).test(cad)) {
      return "multiplicacion";
    } else if (new RegExp(/\%$/g).test(cad)) {
      return "porcentaje";
    } else if (new RegExp(/^\//g).test(cad)) {
      return "division"
    } else if (new RegExp(/^\-/g).test(cad)) {
      return "resta"
    }


    return "suma";
  }
  /**
   * 
   * @param medidaA alto
   * @param medidaL ancho
   */
  extraerMedidas(medidaL, medidaA) {


    let medidasProducto = {
      largo: parseFloat(medidaL),
      alto: parseFloat(medidaA)
    };
    this.ancho = medidasProducto.largo;
    this.alto = medidasProducto.alto;


    this._medidaAl = parseFloat(medidasProducto.alto.toString().split(".")[0]) || 1;
    this._medida2Al = parseFloat(medidasProducto.alto.toString().split(".")[1]) || 0;
    this._medidaAn = parseFloat(medidasProducto.largo.toString().split(".")[0]) || 1;
    this._medida2An = parseFloat(medidasProducto.largo.toString().split(".")[1]) || 0;

    this.calcularAnchoFN();
    this.calcularAltoFN();
    this.changeDetectRef.detectChanges();
  }

  fixearCantidad(_value) {
    return parseFloat(_value + "").toFixed(2);
  }

  buscarCampo(nombre) {

    let ignorados = [
      "_medidaAn",
      "_medida2An",
      "_medidaAl",
      "_medida2Al",
      "cantidad",
      "control_autocompletable"
    ];
    for (let i = 0; i < ignorados.length; i++) {
      if (ignorados[i] == nombre)
        return "";
    }
    for (var i = 0; i < this.campos.length; i++) {

      if (this.campos[i]["nombre"] == nombre) {

        return this.campos[i];
      }
    }
  }

  buscarCampoIndice(nombre) {

    let ignorados = [
      "_medidaAn",
      "_medida2An",
      "_medidaAl",
      "_medida2Al",
      "cantidad",
      "control_autocompletable"
    ];
    for (let i = 0; i < ignorados.length; i++) {
      if (ignorados[i] == nombre)
        return "";
    }
    for (var i = 0; i < this.campos.length; i++) {

      if (this.campos[i]["nombre"] == nombre) {

        return i;
      }
    }
  }

  _ngOnInit() {
    this.metros = Array(100)["fill"](0, 0, 100)["map"]((x, i) => i);
    this.centimetros = Array(100)["fill"](0, 0, 100)["map"]((x, i) => i);
    setTimeout(() => {

      let elements = document.getElementsByClassName("enfoqueRebote");

      for (let x = 0; x < elements.length; x++) {
        elements[x].addEventListener('DOMSubtreeModified', function () {
          elements[x].classList.add("rebotando");
          setTimeout(function () {
            elements[x].classList.remove("rebotando");

          }, 100);

        });
      }


    }, 3000);

  }

  armarParamsResumen() {
    let parte1 = this.detalle.producto_medible == "1" ? {
      "Tamaño": (this.ancho || 0) + "m x " + (this.alto || 1) + "m"
    } : {};


    let arrayData = [];
    for (let clave in this.productoForm.controls) {
      let etiqueta = "";
      this.campos.forEach((val, index) => {
        if (val.tipo == "Múltiple" && clave == val["nombre"]) {
          arrayData.push({
            nombre: val["label"],
            value: this.obtenerValoresdeCampoMultiplo(val["nombre"], index),
          });
          //alert(this.obtenerValoresdeCampoMultiplo(val["nombre"],index));
        } else if (clave == val["nombre"]) {
          arrayData.push(
            {
              nombre: val["label"],
              value: this.productoForm.controls[clave].value
            }
          );

        }


      });

    }

    for (let x = 0; x < arrayData.length; x++) {
      let _aux = arrayData[x];
      //parte1[_aux["label"||""]]=
      //(_aux.opciones[0].valor_selecionado);
      parte1[_aux["nombre"]] = _aux["value"];
    }

    let resumen = {};


    if (this.detalle.cancelar_cantidad != "1") {

      resumen["CANTIDAD"] = this.cantidad || 1;
    }


    if (this.detalle.producto_medible == '1') {
      let subTotal = this.detalle.subtotal;
      resumen = Object.assign(resumen,
        {
          "SUBTOTAL": `$${parseFloat(subTotal).toFixed(2)}`
        }
      );

      if (this.detalle.medida_fija == "variante") {

        resumen["TOTAL M2"] = this.fixearCantidad(this.ancho * this.alto * (this.cantidad || 1)),
          resumen["PRECIO U. " + this.detalle.unidad_medida + "2"] = this.precioUnitario;
      }

    }

    return { general: resumen, campos: parte1 }
  }


  nextStepper(): void {
    let indexSeleccionado = this.stepper.selectedIndex;

    if (indexSeleccionado == 0) {
      this.arrayConfirmaciones[indexSeleccionado]["params"]["data"]["resumen"] = this.armarParamsResumen()

    }
    //let dialogos=_CargaDisenioDialog_|_DireccionDialog_;
    const dialogRef = this.dialog.open(
      this.arrayConfirmaciones[indexSeleccionado].type,
      this.arrayConfirmaciones[indexSeleccionado].params
    );

    this.subscriptions.push(
      this.subsDialog = dialogRef.afterClosed().subscribe(this.arrayConfirmaciones[0].subscribe)
    );
  }




  /**
   * DEMO VARIABLES
  */
  _medidaAn: number = 1;
  _medida2An: number = null;
  _medidaAl: number = 1;
  _medida2Al: number = null;


  metros: number[];
  centimetros: number[];
  agenciaSeleccionada: any = "";
  agenciaSeleccionada1: any = "";
  agenciaSeleccionada2: any = "";
  agenciaSeleccionada3: any = "";
  agenciaSeleccionada4: any = "";
  public imagenesDemo: any[] = [
    { src: "/assets/images/img1_instalacion.png", ref: "Mural de fachada" },
    { src: "/assets/images/img2_instalacion.png", ref: "Puerta de acceso a taller" },
    { src: "/assets/images/img3_instalacion.png", ref: "Mural punto de venta" },
  ];

  tamBase: number = 300;
  tamBaseX: number = 0;
  tamBaseY: number = 0;

  ancho: number = 1;//Metros
  alto: number = 1;//Metros
  proporcion: number = .5;

  color1: string;
  color2: string;
  color3: string;
  cambiaMedida() {
    this._medidaAn = parseFloat(this._medidaAn + "");
    this._medida2An = parseFloat(this._medida2An + "");
    this._medidaAl = parseFloat(this._medidaAl + "");
    this._medida2Al = parseFloat(this._medida2Al + "");

    // Calcular los valores originales (lo que ve el usuario)
    let anchoOriginal = (this._medidaAn + (this._medida2An / 100));
    let altoOriginal = (this._medidaAl + (this._medida2Al / 100));

    // Aplicar redondeo en cuartos tanto al largo como al alto si está habilitado
    this.ancho = this.aplicarRedondeoEnCuartos(anchoOriginal);
    this.alto = this.aplicarRedondeoEnCuartos(altoOriginal); // Ahora el alto también se redondea

    this.proporcion = this.ancho / (this.ancho + this.alto);
    this.calcularAnchoFN();
    this.calcularAltoFN();
    this.calcularPrecio()
    this.changeDetectRef.detectChanges();
  }

  /**
   * Aplica redondeo en cuartos (1/4) para valores menores a 1 metro
   * Solo se aplica si aplicar_redondeo_cuartos == "1"
   * Se aplica tanto al largo como al alto
   * @param valor - Valor original en metros (ej: 0.34)
   * @returns Valor redondeado o valor original
   */
  aplicarRedondeoEnCuartos(valor: number): number {
    // Solo aplicar si está habilitado el redondeo y hay configuración del producto
    if (!this.detalle || this.detalle.aplicar_redondeo_cuartos !== "1") {
      return valor;
    }

    // Solo aplicar si el valor es menor a 1 metro
    if (valor >= 1) {
      return valor;
    }


    // Determinar el cuarto correspondiente
    let valorRedondeado;
    if (valor <= 0.25) {
      valorRedondeado = 0.25;
    } else if (valor <= 0.50) {
      valorRedondeado = 0.50;
    } else if (valor <= 0.75) {
      valorRedondeado = 0.75;
    } else {
      valorRedondeado = 1.00;
    }

    return valorRedondeado;
  }

  unidadMedida: any = [
    { tipo: 1, texto: "metros", abrev: "m" },
    { tipo: 2, texto: "centimetros", abrev: "cm" },
  ]
  unidadMedidaValue: number = 1;

  calculoAncho: string = (this.tamBase * .5) + "px";
  calculoAlto: string = (this.tamBase * .5) + "px";
  calculoAnchoX2: string = (this.tamBase * 1) + "px";
  calculoAltoX2: string = (this.tamBase * 1) + "px";

  calcularAnchoFN(): void {
    this.calculoAncho = this.tamBase * (this.ancho / (this.ancho + this.alto)) + "px";
    this.calculoAnchoX2 = this.tamBase * (this.ancho / (this.ancho + this.alto)) * 2 + "px";
  }

  obtenerValor(val) {
    return parseFloat((this[val] + "").replace(/px/g, ''))
  }

  calcularAltoFN(): void {
    this.calculoAlto = this.tamBase * (this.alto / (this.ancho + this.alto)) + "px";
    this.calculoAltoX2 = this.tamBase * (this.alto / (this.ancho + this.alto)) * 2 + "px";
  }

  keyUpAncho() {
    this.changeDetectRef.detectChanges();
  }
  fAncho: boolean = false;
  focusAncho(): void {
    this.fAncho = true;
  }
  blurAncho(): void {
    this.fAncho = false;
  }

  keyUpAlto() {
    this.changeDetectRef.detectChanges();
  }
  fAlto: boolean = false;
  focusAlto(): void {
    this.fAlto = true;
  }
  blurAlto(): void {
    this.fAlto = false;
  }

  public faceRotacion = 1;

  cambiarRotacion() {
    this.faceRotacion = ++this.faceRotacion % 2;
  }

  borderCuadrado(opcion: string): string {
    return this[opcion] ? '5px solid red' : '2px solid black';
  }


  archivoRef: any;
  public uploadImageDireccion(image) {
    this.archivoRef = image;
  }

  archivoRefDisenioImagen: any;
  public uploadDisenioImagen(image) {
    this.archivoRefDisenioImagen = image.target.files.item(0);
    const params = {
      file: this.archivoRefDisenioImagen,
      cliente_id: this.cliente_id
    };

    this.appState$.dispatch(new SubirImagenDisenioAction(params))
  }

  public subirDisenioImagen() {
    document.getElementById('fileDisenioImagen').click();
    //fileDisenioImagen
  }

  public clickAdjuntos() {
    document.getElementById('adjuntos').click();
  }
  public clickAdjuntoTexto() {
    document.getElementById('textoAdjunto').click();
  }
  public clickAdjuntoLogo() {
    document.getElementById('logoAdjunto').click();
  }
  public clickAdjuntosDisenio() {
    document.getElementById('referenciaAdjunto').click();
  }

  nArchivos: number = 0;
  adjuntoDiseno: any;
  public anadirAdjuntoDiseno(_adjunto) {
    this.adjuntoDiseno = _adjunto.target.files.item(0);
    const params = {
      file: this.adjuntoDiseno,
      cliente_id: this.cliente_id
    };

    this.appState$.dispatch(new AgregarAdjuntoImagenDisenioAction(params))
  }

  public anadirTextoAdjuntoDiseno(_adjunto) {
    this.adjuntoDiseno = _adjunto.target.files.item(0);
    const params = {
      file: this.adjuntoDiseno,
      cliente_id: this.cliente_id
    };

    this.appState$.dispatch(new AgregarTextoDisenioAction(params))
  }

  eleccionLogotipo = 0;

  public anadirLogoAdjuntoDiseno(_adjunto) {
    this.adjuntoDiseno = _adjunto.target.files.item(0);
    const params = {
      file: this.adjuntoDiseno,
      cliente_id: this.cliente_id
    };

    this.appState$.dispatch(new AgregarLogoDisenioAction(params))
  }

  public anadirRefAdjuntoDiseno(_adjunto) {
    this.adjuntoDiseno = _adjunto.target.files.item(0);
    const params = {
      file: this.adjuntoDiseno,
      cliente_id: this.cliente_id
    };

    this.appState$.dispatch(new AgregarReferenciaDisenioAction(params));
  }

  public reducirNombreArchivo(texto: string): string {
    if (texto.length > 17) {
      var regex = new RegExp(texto.substr(7, texto.length - 14), "g")
      return texto.replace(regex, "....")
    }

    return texto;
  }

  eliminarAdjuntoIndice(index) {
    this.adjuntoDiseno = null;
    this.appState$.dispatch(new EliminarAdjuntoDisenioAction(index))
  }

  obtenerExtencion(nombreArchivo) {
    var extencion = "";
    if (nombreArchivo.search(/\.ai$/g) != -1)
      return "ai.png";
    if (nombreArchivo.search(/\.(doc|docx)$/g) != -1)
      return "doc.png";
    if (nombreArchivo.search(/\.file$/g) != -1)
      return "file.png";
    if (nombreArchivo.search(/\.(jpg|jpeg)$/g) != -1)
      return "jpg.png";
    if (nombreArchivo.search(/\.pdf$/g) != -1)
      return "pdf.png";
    if (nombreArchivo.search(/\.png$/g) != -1)
      return "png.png";
    if (nombreArchivo.search(/\.psd$/g) != -1)
      return "psd.png";
    if (nombreArchivo.search(/\.svg$/g) != -1)
      return "svg.png";
    if (nombreArchivo.search(/\.txt$/g) != -1)
      return "txt.png";
    if (nombreArchivo.search(/\.zip$/g) != -1)
      return "zip.png";

    else
      return "file.png"
  }

  arrayConfirmaciones = [
    {
      scope: {},
      class: "ConfirmacionDialog",
      type: ConfirmacionDialog,
      'subscribe': (result) => {
        if (result) this.stepper.next();
      },
      params: {
        width: '520px',
        height: '450px',
        data: { select: 0 },

      },
    },
    {
      scope: {},
      class: "ConfirmacionDialog",
      type: ConfirmacionDialog,
      'subscribe': (result) => {
        if (result) this.stepper.next();
      },
      params: {
        width: '520px',
        height: '200px',
        data: { select: 0 }
      },
    },
    {
      scope: {},
      class: "ConfirmacionDialog",
      type: ConfirmacionDialog,
      'subscribe': (result) => {
        if (result) this.agregarAlCarrito();
      },
      params: {
        width: '520px',
        height: '200px',
        data: { select: 2 }
      },
    }
  ];




  public agregarAlCarrito() {

    this.detalle;
    const param: any = {
      campos: this.productoForm.getRawValue()
    };
    param.totalOptions = parseFloat(this.precioUnitario);
    this.detalle.productCount = Number.isNaN(parseFloat(this.cantidad.toString())) ? 1 : parseFloat(this.cantidad.toString())
    this.detalle._totalOptions = this.detalle.subtotal / this.detalle.productCount;
    this.detalle.totalOptions = this.detalle.subtotal / this.detalle.productCount;

    if (this.opcionDisenioEscojida && this.detalle.tiene_disenio == '1') {
      //inserto el concepto del producto de diseño
      this.detalle["disenio"] = {
        disenio: true,
        name: 'Diseño de ' + this.detalle["name"],
        productCount: 1,
        productId: 563,//producto id especial para diseño
        _totalOptions: this.obtenerPrecioDisenio(),
        totalOptions: this.obtenerPrecioDisenio(),
        price: this.obtenerPrecioDisenio() || "0.00",
        dataFormulario: [{ nombre: "Descripción", "value": 'Diseño de ' + this.detalle["name"] }],
        opcionDisenioEscojida: this.opcionDisenioEscojida,
      }
    }

    let arrayData = [];
    for (let clave in this.productoForm.controls) {
      let etiqueta = "";
      this.campos.forEach((val, index) => {
        if (val.tipo == "Múltiple" && clave == val["nombre"]) {
          arrayData.push({
            nombre: val["label"],
            value: this.obtenerValoresdeCampoMultiplo(val["nombre"], index),
          });
          //alert(this.obtenerValoresdeCampoMultiplo(val["nombre"],index));
        } else if (clave == val["nombre"]) {
          arrayData.push(
            {
              nombre: val["label"],
              value: this.productoForm.controls[clave].value || 'Sin espesificar'
            }
          );

        }


      });

    }

    if (this.detalle.medida_fija == 'variable' && this.detalle.producto_medible && this.detalle.medida_fija == "variable") {
      arrayData.push(
        {
          nombre: "Medidas",
          value: `Largo ${param.campos['_medidaAn']}.${param.campos['_medida2An']} ${this.detalle.unidad_medida} x
               Alto ${param.campos['_medidaAl']}.${param.campos['_medida2Al']} ${this.detalle.unidad_medida}`,
        }
      );
    }

    if (this.descuentosCombinadosAplicados) {
      let ofertaTexto = (this.descuentosCombinadosAplicados.titulo || this.descuentosCombinadosAplicados.nombre || 'Descuento Especial') + " - $" + this.descuentosCombinadosAplicados.precio;
      if (this.descuentosCombinadosAplicados.precioOriginal) {
        ofertaTexto += ` <span class="text-muted" style="text-decoration:line-through; font-size: 0.9em;">(Antes: $${this.descuentosCombinadosAplicados.precioOriginal})</span>`;
      }
      arrayData.push({
        nombre: "Oferta",
        value: ofertaTexto
      });
    }


    //this.detalle["dataFormulario"]=this.productoForm.getRawValue();
    this.detalle["dataFormulario"] = arrayData;
    this.detalle.price = this.detalle.subtotal / this.detalle.productCount;
    //alert(this.detalle.price)
    if (!this.dataFormulario) {
      this.controlSandbox.addItemsToCart(this.detalle, param);
      this.router.navigate(['/cart']);
    } else if (this.dataFormulario && !this.idOrden) {
      this.controlSandbox.addItemsToCartIndex(this.detalle, param, this.indiceCarrito);
      document.location.reload();
    } else if (this.dataFormulario && this.idOrden) {

      this.cotizacion.emit({
        detalle: this.detalle,
        params: param

      });
    }

  }
  precioBaseDinamico: string = "1";
  editarDinamico: boolean = false;
  editarPrecioDinamico(param: boolean) {

    if (param) {
      setTimeout(() => this.precioDinamicoElement.nativeElement.focus(), 0);

    } else {
      this.cambiaPrecioDinamico();
    }

    this.editarDinamico = param;
  }

  cambiaPrecioDinamico() {
    this.precioBaseDinamico = this.precioBaseDinamico.replace(/[^\d\.?\d*]/g, '');
    try {

      this.detalle.precio = parseFloat(this.precioBaseDinamico) || 0;
      this.detalle.price = this.detalle.precio;
      this.precioOriginal = this.detalle.precio;
      this.precioUnitario = this.detalle.precio;
      this.detalle.subtotal = this.detalle.precio * this.cantidad;
      this.calcularPrecio();
    } catch (e) {

      this.detalle.precio = 0;
      this.detalle.price = this.detalle.precio;
      this.precioOriginal = this.detalle.precio;
      this.precioUnitario = this.detalle.precio;
      this.detalle.subtotal = this.detalle.precio * this.cantidad;
      this.calcularPrecio();
    }
  }

  obtenerPrecioDisenio() {
    switch (this.opcionDisenioEscojida) {
      case 1: return 0; break;
      case 2: return 300; break;
      case 3: return 600; break;
      default: return 0;
    }
  }

  /**
   * Esta funcion evita que las facturas den más de 2 decimales
   * @param subtotal 
   * @returns 
   */

  parseoParaFactura(subtotal: any = 1): number {
    try {
      let auxSubtotal = subtotal;
      let _subtotal = subtotal.toString();
      let cantidadU = parseFloat(this.detalle["productCount"] || "1");
      if (this.detalle["nombre_unidad"] == "millar")
        cantidadU *= 1000;
      else if (this.detalle["nombre_unidad"] == "centena")
        cantidadU *= 100;

      let res = (parseFloat(_subtotal) / cantidadU).toFixed(4);
      let indexPunto = -1;
      let indexPunto2;

      if ((indexPunto = res.indexOf(".")) > -1) {
        let decimales = parseFloat(res.substr(indexPunto + 1)).toFixed(4);
        if (decimales.length <= 2) {

          return parseFloat(subtotal);
        }
        else {
          indexPunto2 = auxSubtotal.toString().indexOf(".");

          let redondeo = Math.ceil(parseFloat(decimales) / 100) / 100;
          if (indexPunto2 < 0) {

            res = (`${auxSubtotal.toString()}.${redondeo}`);
          } else {
            res = (`${auxSubtotal.toString().substr(0, indexPunto2)}.${redondeo}`);
          }
          let __subtotal = redondeo * cantidadU;
          res = `${__subtotal}`;

          return parseFloat(res);
        }
      } else {

        return parseFloat(subtotal);
      }


    } catch (error) {

      return subtotal;
    }
  }

  // Listener para detectar cambios en el tamaño de la ventana
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.alturaVentana = event.target.innerHeight;
  }

  // Función para calcular los estilos del mat-card de precios
  obtenerEstilosMatCard() {
    const estilos: any = {
      position: this.estaEnVentanaEmergente ? 'fixed' : 'fixed',
      'padding-top': '20px',
      'padding-bottom': '20px',
      'min-width': '318px',
      'max-width': '318px'
    };

    // Si no está en ventana emergente y la altura es menor a 780px, centrar verticalmente
    if (!this.estaEnVentanaEmergente && this.alturaVentana < 780) {
      estilos['top'] = '50%';
      estilos['transform'] = 'translateY(-50%)';
    }

    return estilos;
  }


}





class ContactoModelo {
  email: string;
  firstName: string;
  grupo_id: string;
  id: string;
  lastName: string;
}